import axios from '../../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/system/sysUser/save',
    method: 'post',
    data
  })
}
// 编辑
export const edit = (data) => {
  return axios({
    url: '/system/sysUser/edit',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: '/system/sysUser/view',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/system/sysUser/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const list = (data) => {
  return axios({
    url: '/system/sysUser/list',
    method: 'post',
    data
  })
}
// 查找用户的菜单权限标识集合
export const findPermissions = (params) => {
  return axios({
    url: '/system/sysUser/findPermissions',
    method: 'post',
    params
  })
}
// 查找部门
export const findDeptTree = (params) => {
  return axios({
    url: '/system/sysUser/findDeptTree',
    method: 'post',
    params
  })
}
// 查找用户类型
export const getUserTypes = (params) => {
  return axios({
    url: '/system/sysUser/getUserTypes',
    method: 'post',
    params
  })
}
// 获取当前登录用户信息
export const findUserInfo = (params) => {
  return axios({
    url: '/system/userInfo/view',
    method: 'post',
    params
  })
}

// 查找用户树
export const findUserTree = (params) => {
  return axios({
    url: '/system/sysUser/findUserTree',
    method: 'post',
    params
  })
}

// 关联路段
export const getProjectSelect = (params) => {
  return axios({
    url: '/common/getProjectSelect',
    method: 'post',
    params
  })
}
// 保存
export const saveRelateProject = (data) => {
  return axios({
    url: '/system/userProject/saveRelateProject',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/user.js